
import * as __star__ from 'text-mask-core';

const {
default: __default__,
conformToMask,
adjustCaretPosition,
createTextMaskInputElement,
__esModule
} = __star__;

export {
conformToMask,
adjustCaretPosition,
createTextMaskInputElement,
__esModule
};
export default __default__;
